import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaEdit } from 'react-icons/fa';
// import './verify.css';
import Notification from '../shared/Notification';
import styles from './verify.module.css';

const Verify = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    const storedEmailOrPhone = sessionStorage.getItem('verifyEmailOrPhone') || '';
    const [originalEmailOrPhone, setOriginalEmailOrPhone] = useState(storedEmailOrPhone);
    const [formData, setFormData] = useState({ emailOrPhone: storedEmailOrPhone, verificationCode: '' });

    const [isVerifyDisabled, setIsVerifyDisabled] = useState(false); 
    const [notification, setNotification] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (e.target.name === 'emailOrPhone' && e.target.value !== originalEmailOrPhone) {
            setIsVerifyDisabled(true); // Disable verify button if email or phone is edited
        }
    };

    const handleEditClick = () => {
        setIsEditing(true); // Enable editing mode
        setIsVerifyDisabled(true); // Disable verify button when editing
    };

    const handleBlur = () => {
        setIsEditing(false); // Disable editing mode on blur
        if (formData.emailOrPhone === originalEmailOrPhone) {
            setIsVerifyDisabled(false); // Enable verify button if no changes
        }
        handleResend(); // Automatically submit on blur
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('/api/authApplicant/verify', formData);
            // console.log(response.data);
            const { token } = response.data;
            localStorage.setItem('token', token);
            localStorage.setItem('notification', 'Signup successful !');
            sessionStorage.removeItem('verifyEmailOrPhone');
            navigate('/home');
        } catch (error) {
            // console.error(error);
            setNotification(error.response.data.message);
        }
    };

    const handleResend = async () => {
        setNotification('Resending Verification Email...1');
        setIsVerifyDisabled(false); // Enable verify button after resend
        try {
            let payload = {};
                if(originalEmailOrPhone===formData.emailOrPhone){
                    payload = { emailOrPhone: originalEmailOrPhone,
                    newEmailOrPhone: formData.emailOrPhone};
                    // console.log('originalEmailOrPhone1', originalEmailOrPhone, 'formData.emailOrPhone', formData.emailOrPhone);
                }
                else{
                    payload = { emailOrPhone: originalEmailOrPhone,
                    newEmailOrPhone: formData.emailOrPhone};
                    //  console.log('originalEmailOrPhone2', originalEmailOrPhone, 'formData.emailOrPhone', formData.emailOrPhone);
                }
            setOriginalEmailOrPhone(formData.emailOrPhone);
            sessionStorage.setItem('verifyEmailOrPhone',formData.emailOrPhone);
            const response = await axios.post('/api/authApplicant/resend-verification', payload);
            // console.log(response.data);
            if(response.data.success){
                setNotification('Verification code sent.');
            }
        } catch (error) {
            // console.error(error);
            // setNotification(error.response.data.message);
        }
    };
    const handleCloseNotification = () => {
        setNotification('');
    };
    return (
        <>
        {notification && (
            <Notification message={notification} onClose={handleCloseNotification} />
        )}
        <div className={styles.verifyContainer}>
            <form onSubmit={handleSubmit} noValidate className={styles.verifyForm}>
                <h2>Verify</h2>
                <div className={styles.editableField}>
                    {isEditing ? (
                        <input
                            type="text"
                            name="emailOrPhone"
                            value={formData.emailOrPhone}
                            onChange={handleChange}
                            onBlur={handleBlur} // Exit editing mode when input loses focus
                            autoFocus
                        />
                    ) : (
                        <p className={styles.infoText}>
                            Verification Code sent to: <strong>{formData.emailOrPhone}</strong>
                            <FaEdit className={styles.editIcon} onClick={handleEditClick} />
                        </p>
                    )}
                </div>

                <input
                    type="text"
                    name="verificationCode"
                    placeholder="Verification Code"
                    value={formData.verificationCode}
                    onChange={handleChange}
                    required
                />
                <div className="error-message">
                    <p>{error}</p>
                </div>
                <button type="submit" className={styles.verifyButton} disabled={isVerifyDisabled}>Verify</button>
                <button type="button" className={styles.resendButton} onClick={handleResend}>
                    Resend Verification Code
                </button>
            </form>
        </div>
        </>
    );
};

export default Verify;
